import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  isCreatingSubject: false,
  isDeleteSubject: false,
  isEditingSubject: false,
  createModal: false,
  subjects: [],
  error: null,
};

export const examSlice = createSlice({
  name: "subject",
  initialState,
  reducers: {
    createSubjectModal: (state, action) => {
      state.createModal = action.payload;
    },
    getSubjectStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getSubjectSuccess: (state, action) => {
      state.isLoading = false;
      state.subjects = action.payload;
      state.error = null;
    },
    getSubjectFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSubjectStart: (state, action) => {
      state.isCreatingSubject = true;
      state.error = null;
    },
    createSubjectSuccess: (state, action) => {
      state.isCreatingSubject = false;
      state.error = null;
    },
    createSubjectFailure: (state, action) => {
      state.isCreatingSubject = false;
      state.error = action.payload;
    },
    getAllSubjectStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getAllSubjectSuccess: (state, action) => {
      state.isLoading = false;
      state.subjects = action.payload;
      state.error = null;
    },
    getAllSubjectFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    deleteSubjectStart: (state, action) => {
      state.isDeleteSubject = true;
    },
    deleteSubjectSuccess: (state, action) => {
      state.isDeleteSubject = false;
    },
    deleteSubjectFailure: (state, action) => {
      state.isDeleteSubject = false;
    },
    editSubjectStart: (state, action) => {
      state.isEditingSubject = true;
    },
    editSubjectSucess: (state, action) => {
      state.isEditingSubject = false;
    },
    editSubjectFailure: (state, action) => {
      state.isEditingSubject = false;
    },
  },
});

export const {
  getSubjectStart,
  getSubjectSuccess,
  getSubjectFailure,
  createSubjectStart,
  createSubjectSuccess,
  createSubjectFailure,
  createSubjectModal,
  getAllSubjectStart,
  getAllSubjectSuccess,
  getAllSubjectFailure,
  deleteSubjectStart,
  deleteSubjectSuccess,
  deleteSubjectFailure,
  editSubjectStart,
  editSubjectSucess,
  editSubjectFailure,
} = examSlice.actions;

const subjectReducer = examSlice.reducer;
export default subjectReducer;
